<div class="popup__wrapper" (click)="backdropClick($event)">
    <div class="popup">
        <div (click)="close()" class="popup__btn-close"></div>
        <div class="popup__title">{{ title }}</div>
        <div class="popup__content">
            <ng-content></ng-content>
        </div>
    </div>
</div>
